define(function(require, exports, module) {

    var Dialog = require('c-dialog');

    var templateList = [
        '<div class="widget-dialog-openbrowser">',
            '<img class="icon" src="//g.cdn.pengpengla.com/oauthgame/html5/20200309/df39f7e778bd63e573eec2513a4aa6b6.png" />',
            '<div class="widget-dialog-content">{{content}}</div>',
            
        '</div>',
        '<style type="text/css">',
            '.widget-dialog-openbrowser { z-index:1000; position: fixed; width:100%;top:0rem;}',
            '.widget-dialog-openbrowser .icon{ width:1.90625rem;height:1.71875rem;display:block;position:absolute;top:0.9375rem; right:60px}',
            '.widget-dialog-openbrowser .widget-dialog-content { text-align: center; width:9.0625rem;margin:0 auto; line-height:0.625rem;  padding-top:3.125rem; color:#fff;}',
        '</style>'
    ];

    let Pop = Dialog.extend({
        defaults: {
            content: '',
            template: templateList.join(''),
            type: 'alert' // 'confirm'
        },
        constructor: function() {
            this.Parent.apply(this, arguments);
            let maskStyle = Object.assign({}, this.mask.get('css'), {
                'z-index': 999
            });

            this.mask.set('css', maskStyle);
            
        },

        create: function(){
            this.Parent.apply(this, arguments);
            let self = this;
            self.mask.set('hideWhenTap',1);
            self.mask.get('el').on('click',()=>{
                self.mask.destroy();
                self.destroy();
            })
            
        }
    });
    module.exports = Pop;
});



// WEBPACK FOOTER //
// ./js/pop/pop-openbrowser.js